import xhr from 'xhr.js';
import auth from 'services/auth';

const people = {

    bulkEditPeople: async (options) => {
        const account_id = auth.getAccountId();
        console.log(options);

        const res = await xhr.put(`/people?${options.filters_query_string}`, {
            all: options.all,
            people_ids: options.people_ids,
            account_id,
            bulk_edit_column_id: options.bulk_edit_column_id,
            bulk_edit_column_value: options.bulk_edit_column_value
        },
        {
            withCredentials: true
        });
        return res.data;
    },
    getPeopleCount: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/people/count?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    getPanelIncentives: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/people-incentives?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    getPersonUuid: async (account_uuid, person_uuid) => {
        const res = await xhr.get(`/people-consent/${account_uuid}/${person_uuid}`, {
            withCredentials: true
        });
        return res.data;
    },
    consentOptIn: async (account_uuid, person_uuid, opt_in_value) => {
        const res = await xhr.post(
            `/people-consent/${account_uuid}/${person_uuid}/opt-in`,
            { opt_in_value },
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    consentDeleteData: async (account_uuid, person_uuid) => {
        const res = await xhr.post(
            `/people-consent/${account_uuid}/${person_uuid}/delete`,
            {},
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    getPanelSignupPublic: async (account_hash, panel_form_id) => {
        const res = await xhr.get(`/panel-signup-form-public/${account_hash}/${panel_form_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    getPanelSignupPublicWithSlug: async (panel_signup_custom_slug) => {
        const res = await xhr.get(`/panel-signup-form-public-slug/${panel_signup_custom_slug}`, {
            withCredentials: true
        });
        return res.data;
    },
    getPanelSignupForms: async () => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/panel-signup-forms?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    getPanelSignupForm: async (form_id) => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/panel-signup-forms/${form_id}?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    deletePanelSignupForm: async (form_id) => {
        const account_id = auth.getAccountId();
        const res = await xhr.delete(`/panel-signup-forms/${form_id}?account_id=${account_id}`, {
            withCredentials: true
        });
        return res.data;
    },
    createPanelSignupForm: async (title, description) => {
        const account_id = auth.getAccountId();
        const res = await xhr.post(`/panel-signup-forms?account_id=${account_id}`, 
            { title, description },
            {
                withCredentials: true
            });
        return res.data;
    },
    getScreenerTranslation: async (panel_form_id) => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(`/panel-signup-translation/${panel_form_id}?account_id=${account_id}`,{
            withCredentials: true
        });
        return res.data;
    },
    updateScreenerTranslation: async (panel_form_id, screener_translation) => {
        const account_id = auth.getAccountId();
        const res = await xhr.put(
            `/panel-signup-translation/${panel_form_id}?account_id=${account_id}`,
            { screener_translation },
            {
                withCredentials: true
            }
        );

        return res.data;
    },
    updatePanelForm: async (panel_form) => {
        const account_id = auth.getAccountId();
        const res = await xhr.put(
            `/panel-signup-forms/${panel_form.id}?account_id=${account_id}`,
            { ...panel_form },
            {
                withCredentials: true
            }
        );

        return res.data;
    },
    updateColumn: async (column) => {
        const account_id = auth.getAccountId();
        const res = await xhr.put(
            `/columns/${column.id}?account_id=${account_id}`,
            { ...column },
            {
                withCredentials: true
            }
        );

        return res.data;
    },
    getUniqueColumnValues: async (column_id) => {
        const account_id = auth.getAccountId();
        const res = await xhr.get(
            `/columns/${column_id}/unique-values?account_id=${account_id}`,
            {
                withCredentials: true
            }
        );

        return res.data;
    },
    createPersonPanelistExperience: async (account_uuid, person) => {
        const res = await xhr.post(
            `/people-public?account_uuid=${account_uuid}`,
            { ...person },
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    loginPersonPanelistExperience: async (account_uuid, email, password) => {
        const res = await xhr.post(
            `/people-public-login?account_uuid=${account_uuid}`,
            { email, password },
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    checkAuthPanelistExperience: async (account_uuid) => {
        const res = await xhr.get(
            `/me-panelist?account_uuid=${account_uuid}`,
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    logoutPanelistExperience: async (account_uuid) => {
        const res = await xhr.get(
            `/logout-panelist?account_uuid=${account_uuid}`,
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    sendForgotPasswordEmailPanelistExperience: async (account_uuid, email) => {
        const res = await xhr.post(
            `/people-public-forgot-password?account_uuid=${account_uuid}`,
            { email },
            {
                withCredentials: true
            }
        );
        return res.data;
    },
    useResetPasswordToken: async (token, password, password_confirmation) => {
        const res = await xhr.post(
            `/reset-password-use-token`,
            { token, password, password_confirmation },
            {
                withCredentials: true
            }
        );
        return res.data;
    },
};

export default people;
